import { TabsContent } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { PenLine } from "lucide-react";
import TemPlete1 from "../card/gift-card/templete1";
import TemPlete2 from "../card/gift-card/templete2";
import TemPlete3 from "../card/gift-card/templete3";
import Template4 from "../card/gift-card/templete4";
import TemplateCardSkeleton from "@/components/skeleton/template-card-skeleton";
import { getTemplateBySerial } from "@/lib/loyalty-template-utils";

const cards = [
  { title: "Gift Card Template 1", Component: TemPlete1 },
  { title: "Gift Card Template 2", Component: TemPlete2 },
  { title: "Gift Card Template 3", Component: TemPlete3 },
  { title: "Gift Card Template 4", Component: Template4 },
];

function GiftCardTabs({ templates = [], getLoading = false, onOpenCreate, onOpenEdit }) {

  return (
    <TabsContent value="gift_card">
      {getLoading ? <TemplateCardSkeleton /> : null}
      {!getLoading ? (
      <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
        {cards.map(({ title, Component }, index) => {
          const template = getTemplateBySerial(templates, index + 1);

          return (
            <Card key={title}>
              <CardHeader className="pb-2">
                <div className="flex justify-between items-center">
                  <h3 className="text-base">{template?.title || title}</h3>
                  <div className="p-1.5 bg-cblack7 rounded-full">
                    <PenLine
                      className="w-4 h-4 cursor-pointer hover:text-white transition-all duration-300 text-muted-foreground"
                      onClick={() => onOpenEdit(template)}
                    />
                  </div>
                </div>
              </CardHeader>
              <CardContent className="pb-4 mt-4">
                <Component template={template} />
              </CardContent>
            </Card>
          );
        })}
      </div>
      ) : null}
    </TabsContent>
  );
}

export default GiftCardTabs;
